import React from "react";
import { connect } from "react-redux";
import { ProgressBar, Dropdown } from "react-bootstrap";
import PropTypes from "prop-types";
import { onPressReferralsDropDown } from "../../actions";
import { Link } from "react-router-dom";
import axios from "axios";

class ReferralsCard extends React.Component {
  state = {
    brands: [], // To store fetched brand data
  };

  // Fetch brand data from the API when the component mounts
  componentDidMount() {
    axios
      .get("https://brand.aasmo.in/api/admin/brandsnew")
      .then((response) => {
        // Update state with the brand names
        this.setState({ brands: response.data.data });
      })
      .catch((error) => {
        console.error("There was an error fetching the brand data:", error);
      });
  }

  render() {
    const { brands } = this.state; // Get the brand data from state

    return (
      <div className="card">
        <div className="header">
          <h2>Brands</h2>
          <Dropdown as="ul" className="header-dropdown">
            <Dropdown.Toggle variant="success" as="li" id="dropdown-basic">
              <Dropdown.Menu
                as="ul"
                className="dropdown-menu dropdown-menu-right"
              >
                <li>
                  <Link to="#">Action</Link>
                </li>
                <li>
                  <Link to="#">Another Action</Link>
                </li>
                <li>
                  <Link to="#">Something else</Link>
                </li>
              </Dropdown.Menu>
            </Dropdown.Toggle>
          </Dropdown>
        </div>
        <div className="body">
          <ul className="list-unstyled list-referrals">
            {/* Loop through the brands array and display each brand's name */}
            {brands.map((brand, index) => (
              <li key={brand._id}>
                <p>
                  <span className="value"></span>
                  <span className="text-muted float-right">{brand.name}</span>
                </p>
                <ProgressBar
                  className="progress progress-xs progress-transparent custom-color-blue"
                  now={87} // You can update this dynamically as well
                  min={0}
                  max={100}
                />
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  }
}

ReferralsCard.propTypes = {
  onPressReferralsDropDown: PropTypes.func.isRequired,
};

const mapStateToProps = ({ analyticalReducer }) => ({
  referralsDropDown: analyticalReducer.referralsDropDown,
});

export default connect(mapStateToProps, {
  onPressReferralsDropDown,
})(ReferralsCard);
